import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import Choices from 'Choices.js';

export default class Select extends Component {
	choices;

	constructor(element) {
		super(element);

		this.ref = {
			select: null,
			flag:   null,
		};

		this.flagPath = './img/flags/';

		this.isDesktop = false;

		this.enquireHandler = {
			match:   () => {
				this.isDesktop = true;
			},
			unmatch: () => {
				this.isDesktop = false;
			},
		};
	}

	old_prepare() {
		enquire.register(queries.mediumUp, this.enquireHandler);
		if (this.isDesktop) {
			this.choices = new Choices(this.ref.select, {
				searchEnabled: false,
				itemSelectText: "",
				shouldSort: false,
				placeholder: true,
			});
		}

		// add flags to select
		if (this.element.classList.contains("Select--flags")) {
			if (this.isDesktop) {
				this.choices.passedElement.element.addEventListener(
					"addItem",
					(event) => {
						//console.log(event.detail.id);
						//console.log(event.detail.value);
						this.flagHandler(event.detail.value);
						//console.log(event.detail.label);
						//console.log(event.detail.customProperties);
						//console.log(event.detail.groupValue);
					},
					false
				);
			} else {
				this.element.firstElementChild.addEventListener("change", (e) => {
					this.flagHandler(e.target.value);
				});
			}
		}
	}


	prepare() {
		enquire.register(queries.mediumUp, this.enquireHandler);

		this.choices = new Choices(this.ref.select, {
			searchEnabled:  false,
			itemSelectText: '',
			shouldSort:     false,
			placeholder:    true,
			allowHTML: true,
		});

		console.log('Element is:');
		console.log(this.choices.passedElement.element);

		console.log('choice');
		this.choices.passedElement.element.addEventListener('showDropdown', (event) => {
			console.log(event);
		})

		// this.ref.select.addEventListener('click', (event) => {
		// 	console.log('clicked...');
		// })

		// console.log(this.ref.select);
		// console.log(typeof this.ref.select);

		// add flags to select
		if (this.element.classList.contains('Select--flags')) {
			this.choices.passedElement.element.addEventListener(
				'addItem',
				(event) => {
					this.flagHandler(event.detail.value);
				},
				false
			);
		}
	}

	destroy() {
		enquire.unregister(queries.mediumMax, this.enquireHandler);
	}

	flagHandler(iso) {
		let flag = this.element.getElementsByClassName('Flag');
		flag[0].className = 'Flag Flag--' + iso;

		// if(this.ref.flag) this.ref.flag.setAttribute("src", flagPath + iso.toLocaleLowerCase() + ".svg");
	}
}
